export const MAX_OPTIONS = 10;
export const MAX_QUESTIONS = 100;
